import React from "react";
import Link from "next/link";

import Paper from "ui/Paper/Paper";

import LazyImage from "ui/LazyImage/LazyImage";
import { useUrl } from "helpers/hooks";
import { cn } from "helpers/style";
import styles from "./CategoriesItem.module.scss";

type Props = {
  category: Entity.Category;
  multiColumn?: boolean;
};

const CategoriesItem: React.FC<Props> = ({ category, multiColumn }: Props) => {
  const { getEntityLinkProps } = useUrl();
  return (
    <div className={styles.categoriesItemWrapper}>
      <Paper elevation={1} withHover>
        <Link
          style={{
            backgroundColor: category.background
              ? `#${category.background}`
              : null,
          }}
          {...getEntityLinkProps("category", category)}
          className={cn([
            styles.categoriesItemTitle,
            !category.children?.length && styles.categoriesItemTitleRounded,
          ])}
        >
          {category.img && (
            <LazyImage
              width={140}
              height={140}
              src={category.img}
              alt={category.name}
              title={category.name}
              className={styles.categoriesItemImg}
            />
          )}
          {category.name}
        </Link>

        {category.children?.length > 0 && (
          <div
            className={cn([
              styles.categoriesItemList,
              multiColumn && styles.categoriesItemListMultiColumn,
            ])}
          >
            {category.children.map((item, i) => {
              if (item.isMeta) return null;

              return (
                <Link
                  key={i}
                  {...getEntityLinkProps("category", item)}
                  className={cn([
                    styles.categoriesItemListItem,
                    multiColumn && styles.categoriesItemListItemMultiColumn,
                  ])}
                >
                  {item.name}
                </Link>
              );
            })}
          </div>
        )}
      </Paper>
    </div>
  );
};

export default CategoriesItem;
